import { useState } from 'react';
import { api } from '@/lib/api';
import { getErrorMessage } from '@/lib/error-message';

export function useWidgetToggle(organizationId: string) {
  const [error, setError] = useState<string | null>(null);
  const [pendingWidgetId, setPendingWidgetId] = useState<string | null>(null);

  const setEnabled = async (widgetId: string, enabled: boolean) => {
    setError(null);
    setPendingWidgetId(widgetId);

    const { error: apiError } = await api.organizations({ organizationId }).widgets({ widgetId }).post({ enabled });

    setPendingWidgetId(null);

    if (apiError) setError(getErrorMessage(apiError, 'Failed to update this setting'));
  };

  return { error, pendingWidgetId, setEnabled };
}
